import Icon from '../../../commonComponent/icon/Icon';
import {t} from "../../../i18n";
import ProgressiveImage from '../../../commonComponent/image/ProgressiveImage';
import SectionPanel, {SectionCopy} from '../../../commonComponent/section/SectionPanel';
import {imageAssets} from '../../../assets/imageAssets';

/**
 * Les informations pratiques.
 *
 * Les trois textes vivaient en dur dans ce fichier. Ils sont dans `text.json` avec tous les
 * autres : un prochain restaurant n'a plus à ouvrir un composant pour dire qu'il refuse les
 * chèques.
 */
const InfoPractice = () => { return (
    <section data-reveal className="content-row practical-row">
        <SectionPanel variant="secondary" title={t("infoPracticeTitle")}>
            <p className="practical-payment">
                {t("infoPracticePayment")}
                <span className="practical-icons" aria-hidden="true">
                    <Icon name="credit-card"/>
                    <Icon name="cash"/>
                </span>
            </p>
            <SectionCopy paragraphs={[t("infoPracticeTicket"), t("infoPracticePrices")]}/>
        </SectionPanel>

        <article className="image-surface practical-image">
            <ProgressiveImage asset={imageAssets.infoPractice} sizes="(max-width: 767px) 100vw, 50vw"
                              alt={t("altInfoPractice")} className="surface-image"/>
        </article>
    </section>
); };

export default InfoPractice;
